import { UserType } from 'api'

export namespace permissions {
  export const canEditClient: UserType[] = [UserType.OWNER, UserType.DEBUG]
}

export default permissions
